import React from 'react';
import { RGBColor, ColorResult } from 'react-color';
import ColorCircleBlock from './ColorCircleBlock';
import { stringToColorResult } from './useColorPickerConverter';

export interface Props {
    presetColors?: RGBColor[] | string[];
    onChange?: (color: ColorResult) => void;
    selectedColor: ColorResult;
    removeTransparent: boolean;
}

const areColorObjectEqual = (color1: RGBColor, color2: RGBColor) => {
    return (
        color1?.r === color2?.r &&
        color1?.g === color2?.g &&
        color1?.b === color2?.b &&
        color1?.a === color2?.a
    );
};

const ColorPickerCircles = ({
    // Demo preset swatches, not design tokens; see .claude/rules/styling.md
    presetColors = [
        'rgba(222, 111, 98, 1)',
        'rgba(38, 35, 8, 1)',
        'rgba(115, 84, 198, 1)',
        'rgba(201, 231, 55, 1)'
    ],
    onChange,
    selectedColor,
    removeTransparent
}: Props) => {
    let presetColorsWithTransparent;

    const presetColorsWithoutTransparent = (presetColors as string[]).filter(
        presetColor =>
            presetColor !== 'transparent' && presetColor !== 'rgba(0, 0, 0, 0)'
    );

    if (!removeTransparent) {
        // First color in preset is always transparent
        presetColorsWithTransparent = [
            'rgba(0, 0, 0, 0)',
            ...presetColorsWithoutTransparent
        ];
    }

    const presetColorsToLowerCase: string[] = (
        presetColorsWithTransparent || presetColorsWithoutTransparent
    ).map(color => color.toLowerCase());

    // Convert hex to rgba format & remove duplicates
    const colorResultPresetColors = [...new Set(presetColorsToLowerCase)].map(
        color => {
            return stringToColorResult(color);
        }
    );

    return (
        <>
            {colorResultPresetColors.map(presetColor => {
                return (
                    <ColorCircleBlock
                        key={`${Math.random() * 1000}`}
                        onClick={() => onChange(presetColor)}
                        color={presetColor.rgb}
                        alpha={presetColor?.rgb.a}
                        isSelected={areColorObjectEqual(
                            presetColor.rgb,
                            selectedColor.rgb
                        )}
                    />
                );
            })}
        </>
    );
};

export default ColorPickerCircles;
